<template>
  <div class="conatainer">
    <router-view></router-view>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.container {
  @apply max-w-[1000px] mx-auto my-0;
}
</style>
